import { FC } from 'react';

import { IconProps } from './types';

export const ArrowIcon: FC<IconProps> = ({ size, height = 16, width = 10, color = '#06519E' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 10 16"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M8.098 7.098a.997.997 0 0 1-.293.707l-6 6A.999.999 0 1 1 .391 12.39l5.293-5.293L.391 1.805A.999.999 0 1 1 1.805.39l6 6a.997.997 0 0 1 .293.707Z"
		/>
	</svg>
);
